import { buildUrl } from "helpers";
import { instance } from "libs/api";

import { ApiRoutesWhatsAppAdProducts } from "../../constants";
import { IAdProduct } from "../../whatsappAdProducts.types";

export const requestGetAdProduct = async (id: string): Promise<IAdProduct> => {
  return await instance.get(buildUrl(ApiRoutesWhatsAppAdProducts.AdProducts, id));
};
